import { useNavigate } from 'react-router-dom';
import styles from './Eventos.module.scss';

interface LinkItem {
  readonly label: string;
  readonly href: string;
}

const eventos: LinkItem[] = [
  {
    label:
      'Webinar DIEF-CFEM: Nova Resolução, Sistema de Declaração e Transparência na Gestão Mineral - 18/09/2025',
    href: 'https://enc.serpro.gov.br/5bc824c9',
  },
];

function Eventos() {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <button
        className={styles.back}
        onClick={() => navigate('/')}
        type='button'
      >
        <i className='fas fa-arrow-left' aria-hidden='true' /> Voltar
      </button>

      <section className={styles.section}>
        <div className={styles.sectionHeader}>
          <div className={styles.iconWrap}>
            <i className='fas fa-calendar-day' aria-hidden='true' />
          </div>
          <div>
            <h2 className={styles.sectionTitle}>Eventos</h2>
            <p className={styles.sectionSub}>
              Webinars e encontros sobre a Plataforma de Gestão de Recursos
              Minerais
            </p>
          </div>
        </div>
        <ul className={styles.list}>
          {eventos.map((item) => (
            <li key={item.href} className={styles.listItem}>
              <a
                href={item.href}
                target='_blank'
                rel='noopener noreferrer'
                className={styles.link}
              >
                <span>{item.label}</span>
                <i
                  className={`fas fa-external-link-alt ${styles.externalIcon}`}
                  aria-hidden='true'
                />
              </a>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export default Eventos;
